var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('div', [!_vm.printRead ? _c('div', {
    staticClass: "res-step"
  }, [_c('el-steps', _vm._g(_vm._b({
    style: _vm.styleWidth,
    attrs: {
      "active": _vm.active
    }
  }, 'el-steps', _vm.getComAttr, false), _vm.$listeners), _vm._l(_vm.stepOptions, function (item) {
    return _c('el-step', {
      key: item.title,
      style: _vm.styleWidth,
      attrs: {
        "title": item.title,
        "description": item.description,
        "icon": item.icon
      }
    }, [_c('template', {
      slot: "icon"
    }, [item.slots && item.slots.icon ? _c('span', {
      domProps: {
        "innerHTML": _vm._s(item.slots.icon)
      }
    }) : _vm._t("icon")], 2), _c('template', {
      slot: "title"
    }, [item.slots && item.slots.title ? _c('span', {
      domProps: {
        "innerHTML": _vm._s(item.slots.title)
      }
    }) : _vm._t("title")], 2), _c('template', {
      slot: "description"
    }, [item.slots && item.slots.description ? _c('span', {
      domProps: {
        "innerHTML": _vm._s(item.slots.description)
      }
    }) : _vm._t("description")], 2)], 2);
  }), 1)], 1) : _c('div', {
    staticClass: "res-step"
  }, [_c('div', {
    staticClass: "res-print-read m-l-5"
  }, [_vm._v(_vm._s(_vm.valueToLabel))])]), _vm.description ? _c('div', {
    staticClass: "cmp-desc"
  }, [_vm._v(" " + _vm._s(_vm.description) + " ")]) : _vm._e()]);
};

var staticRenderFns = [];
export { render, staticRenderFns };